import { render } from "./ThemeForm.vue?vue&type=template&id=26e3e25e"
import script from "./ThemeForm.vue?vue&type=script&lang=js"
export * from "./ThemeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__